/*
 * Copyright (c) 2005-2008, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: haxe.io
 * class: Bytes
 * root Object
 * @constructor
 */
haxe.io.Bytes = function(length,b) {
	this.length = length;
	this.b = b;
};
$hxClasses['haxe.io.Bytes'] = haxe.io.Bytes;
/** @private @type {Array} */
haxe.io.Bytes.__name__ = ["haxe","io","Bytes"];

/**
 * alloc
 *
 * $type TFun([{ name => length, t => TInst(Int,[]), opt => false }],TInst(haxe.io.Bytes,[]))
 * @public
 * @static
 * @param {number}  length 
 * @return {haxe.io.Bytes}
 */
haxe.io.Bytes.alloc = function(length) {
	/** @type {Array} */
	var a = [];
	/** @type {number} */
	var _g = 0;
	while(_g < length) {
		a.push(0);
	}
	return new haxe.io.Bytes(length,a);
};


/**
 * ofString
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(haxe.io.Bytes,[]))
 * @public
 * @static
 * @param {string}  s 
 * @return {haxe.io.Bytes}
 */
haxe.io.Bytes.ofString = function(s) {
	/** @type {Array} */
	var a = [];
	/** @type {number} */
	var _g1 = 0;
	/** @type {number} */
	var _g = s.length;
	while(_g1 < _g) {
		/** @type {number} */
		var i = _g1++;
		/** @type {number} */
		var c = s.charCodeAt(i);
		if(c <= 127) a.push(c); else if(c <= 2047) {
			a.push(192 | c >> 6);
			a.push(128 | c & 63);
		} else if(c <= 65535) {
			a.push(224 | c >> 12);
			a.push(128 | c >> 6 & 63);
			a.push(128 | c & 63);
		} else {
			a.push(240 | c >> 18);
			a.push(128 | c >> 12 & 63);
			a.push(128 | c >> 6 & 63);
			a.push(128 | c & 63);
		}
	}
	return new haxe.io.Bytes(a.length,a);
};


/**
 * ofData
 *
 * $type TFun([{ name => b, t => TType(haxe.io.BytesData,[]), opt => false }],TInst(haxe.io.Bytes,[]))
 * public static function ofData( b : BytesData )
 * @public
 * @static
 * @param {haxe.io.BytesData}  b 
 * @return {haxe.io.Bytes}
 */
haxe.io.Bytes.ofData = function(b) {
	return new haxe.io.Bytes(b.length,b);
};


/**
 * getData
 *
 * $type TFun([],TType(haxe.io.BytesData,[]))
 * @public
 * @this haxe.io.Bytes
 * @return {haxe.io.BytesData}
 */
haxe.io.Bytes.prototype.getData = function() {
	return this.b;
};


/**
 * toHex
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this haxe.io.Bytes
 * @return {string}
 */
haxe.io.Bytes.prototype.toHex = function() {
	/** @type {StringBuf} */
	var s = new StringBuf();
	/** @type {Array} */
	var chars = [];
	/** @type {string} */
	var str = "0123456789abcdef";
	/** @type {number} */
	var _g1 = 0;
	/** @type {number} */ 
	var _g = str.length;
	/** @type {number} */
	var i;
	while(_g1 < _g) {
		i = _g1++;
		chars.push(HxOverrides.cca(str,i));
	}
	_g1 = 0;
	_g = this.length;
	while(_g1 < _g) {
		i = _g1++;
		/** @type {number} */
		var c = this.b[i];
		s.b += String.fromCharCode(chars[c >> 4]);
		s.b += String.fromCharCode(chars[c & 15]);
	}
	return s.b;
};


/**
 * toString
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this haxe.io.Bytes
 * @return {string}
 */
haxe.io.Bytes.prototype.toString = function() {
	return this.readString(0,this.length);
};


/**
 * readString
 *
 * $type TFun([{ name => pos, t => TInst(Int,[]), opt => false },{ name => len, t => TInst(Int,[]), opt => false }],TInst(String,[]))
 * @public
 * @this haxe.io.Bytes
 * @param {number}  pos 
 * @param {number}  len 
 * @return {string}
 */
haxe.io.Bytes.prototype.readString = function(pos,len) {
	if(pos < 0 || len < 0 || pos + len > this.length) throw haxe.io.Error.OutsideBounds;
	/*  TODO: test me */
	/* 		return untyped __call__("call_user_func_array", "pack", __call__("array_merge", __call__("array", "C*"), __call__("array_slice", b.�a, pos, len))); */
	/** @type {string} */
	var s = "";
	/** @type {haxe.io.BytesData} */
	var b = this.b;
	/** @type {string} */
	var fcc = String.fromCharCode;
	/** @type {number} */
	var i = pos;
	/** @type {number} */
	var max = pos + len;
	/** @type {number} */
	var c2;
	/*  utf8-encode */
	while(i < max) {
		/** @type {number} */
		var c = b[i++];
		if(c < 128) {
			if(c == 0) break;
			s += fcc(c);
		} else if(c < 224) s += fcc((c & 63) << 6 | b[i++] & 127); else if(c < 240) {
			c2 = b[i++];
			s += fcc((c & 31) << 12 | (c2 & 127) << 6 | b[i++] & 127);
		} else {
			c2 = b[i++];
			/** @type {number} */
			var c3 = b[i++];
			s += fcc((c & 15) << 18 | (c2 & 127) << 12 | c3 << 6 & 127 | b[i++] & 127);
		}
	}
	return s;
};


/**
 * compare
 *
 * $type TFun([{ name => other, t => TInst(haxe.io.Bytes,[]), opt => false }],TInst(Int,[]))
 * @public
 * @this haxe.io.Bytes
 * @param {haxe.io.Bytes}  other 
 * @return {number}
 */
haxe.io.Bytes.prototype.compare = function(other) {
	/** @type {haxe.io.BytesData} */
	var b1 = this.b;
	/** @type {haxe.io.BytesData} */
	var b2 = other.b;
	/** @type {number} */
	var len = this.length < other.length?this.length:other.length;
	/** @type {number} */
	var _g = 0;
	while(_g < len) {
		/** @type {number} */
		var i = _g++;
		if(b1[i] != b2[i]) return b1[i] - b2[i];
	}
	return this.length - other.length;
};


/**
 * sub
 *
 * $type TFun([{ name => pos, t => TInst(Int,[]), opt => false },{ name => len, t => TInst(Int,[]), opt => false }],TInst(haxe.io.Bytes,[]))
 * @public
 * @this haxe.io.Bytes
 * @param {number}  pos 
 * @param {number}  len 
 * @return {haxe.io.Bytes}
 */
haxe.io.Bytes.prototype.sub = function(pos,len) {
	if(pos < 0 || len < 0 || pos + len > this.length) throw haxe.io.Error.OutsideBounds;
	/*  TODO: test me */
	return new haxe.io.Bytes(len,this.b.slice(pos,pos + len));
};


/**
 * blit
 *
 * $type TFun([{ name => pos, t => TInst(Int,[]), opt => false },{ name => src, t => TInst(haxe.io.Bytes,[]), opt => false },{ name => srcpos, t => TInst(Int,[]), opt => false },{ name => len, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this haxe.io.Bytes
 * @param {number}  pos 
 * @param {haxe.io.Bytes}  src 
 * @param {number}  srcpos 
 * @param {number}  len 
 * @return {void}
 */
haxe.io.Bytes.prototype.blit = function(pos,src,srcpos,len) {
	if(pos < 0 || srcpos < 0 || len < 0 || pos + len > this.length || srcpos + len > src.length) throw haxe.io.Error.OutsideBounds;
	/*  TODO: test me */
	/** @type {haxe.io.BytesData} */
	var b1 = this.b;
	/** @type {haxe.io.BytesData} */
	var b2 = src.b;
	/** @type {number} */
	var i;

	if(b1 == b2 && pos > srcpos) {
		i = len;
		while(i > 0) {
			i--;
			b1[i + pos] = b2[i + srcpos];
		}
		return;
	}
	/** @type {number} */
	var _g = 0;
	while(_g < len) {
		i = _g++;
		b1[i + pos] = b2[i + srcpos];
	}
};


/**
 * set
 *
 * $type TFun([{ name => pos, t => TInst(Int,[]), opt => false },{ name => v, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this haxe.io.Bytes
 * @param {number}  pos 
 * @param {number}  v 
 * @return {void}
 */
haxe.io.Bytes.prototype.set = function(pos,v) {
	this.b[pos] = v & 255;
};


/**
 * get
 *
 * $type TFun([{ name => pos, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * @public
 * @this haxe.io.Bytes
 * @param {number}  pos 
 * @return {number}
 */
haxe.io.Bytes.prototype.get = function(pos) {
	return this.b[pos];
};

/** @private @type {haxe.io.BytesData} */
haxe.io.Bytes.prototype.b = null;
/** @type {number} */
haxe.io.Bytes.prototype.length = null;
/** @type {haxe.io.Bytes} */
haxe.io.Bytes.prototype.__class__ = haxe.io.Bytes;
